import {
  BadRequestError,
  ForbiddenError,
  NetworkError,
  NotAllowedError,
  NotFoundError,
  UnauthorizedError,
} from '@sravni/utils/lib/errors/network';

export const createApplicationError = (status: number, message?: string): NetworkError => {
  switch (status) {
    case 400:
      return new BadRequestError({ message });
    case 401:
      return new UnauthorizedError(message);
    case 403:
      return new ForbiddenError(message);
    case 404:
      return new NotFoundError(message);
    case 405:
      return new NotAllowedError(message);
    default:
      return new NetworkError(message);
  }
};
